export interface RequestBusinessTravelInterface {
  choices: string[];
  other_description: string;
  companyName: string;
  contactName: string;
  contactEmail: string;
  contactMobile: string;
}

export interface ResponseBusinessTravelContactInterface {
  status: boolean;

  message: string;
}

export class ResponseBusinessTravelContact {
  status: boolean;

  message: string;

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || "";
  }
}
